import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { selectedAlgoState } from "../../recoil";
import AlgoImage from "../../assets/algoExample.png";
import { t } from "i18next";
import CustomButton from "../customComponent/CustomButton";
import { postPreClass } from "../../services/projectService";
import { PreClassStep } from "@types";
import Scatter2DChart from "./Scatter2DChart";

// interface AlgoThirdStepProps extends PreClassStep {
//   images: string[];
// }

export default function AlgoThirdStep({
  setCurrentStep,
}: // images,
PreClassStep) {
  const { id, algoId } = useParams();
  const navigate = useNavigate();
  const [selectedAlgo, setSelectedAlgo] = useRecoilState(selectedAlgoState);

  const handleAlgoConfirm = async () => {
    try {
      const response = await postPreClass(Number(id), selectedAlgo.classCount!);
      console.log(response);
      navigate(`/project/${id}/analysis`);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        gap: 2,
      }}
    >
      <Typography>
        {selectedAlgo.classCount}개에 따른 {selectedAlgo.algoName}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Scatter2DChart />
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 2,
          gap: "5px",
        }}
      >
        <CustomButton
          text={t("Confirm")}
          variant="contained"
          onClick={handleAlgoConfirm}
        />
        <CustomButton
          text={t("Edit")}
          variant="contained"
          onClick={handleAlgoConfirm}
        />
        <CustomButton text={t("Cancel")} variant="outlined" />
      </Box> */}
    </Box>
  );
}
